module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/thead-border.554b4011.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/thead-border.png
// module id = 2762
// module chunks = 11